import React, { useEffect } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShuffle } from "@fortawesome/free-solid-svg-icons";
import "./index.css";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { useLazyGetRestaurantsByOwnerIdQuery } from "../../../redux/services/restaurantServices";
import { Restaurant } from "../../../components/ReastaurantSlectModal";
import {
  openInitialSlectReastaurantModla,
  setSelectedRestaurantDetails,
} from "../../../redux/restaurantsSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { isRestaurantOpen } from "../../../utility/Utility";
import TableLoadingComponent from "../../../components/TableLoadingComponent";
import ViewButtonComponent from "../../../components/ViewButtonComponent";
import { useLazyGetRestaurantDetailsByIdQuery } from "../../../redux/services/restaurantServices";

const RestaurantDetailsTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const ownerId = localStorage.getItem("ownerID") || "";

  const [trigger, { data, isLoading }] =
    useLazyGetRestaurantsByOwnerIdQuery();

  const [triggerRestaurantDetails] = useLazyGetRestaurantDetailsByIdQuery();

  useEffect(() => {
    const restaurants = data?.restaurantList?.restaurants || [];
    if (restaurants.length === 1 && restaurants[0].status?.toLowerCase() === "approved") {
      const selected = restaurants[0];
      localStorage.setItem("selectedRestaurantId", selected.id || "");
      // Get complete restaurant details instead of using the basic restaurant object
      handleSelectRestaurant(selected.id || "");
      dispatch(openInitialSlectReastaurantModla(true));
      toast.success("Automatically selected the only approved restaurant.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, dispatch]);

  const handleSelectRestaurant = async (restaurantId: string) => {
    try {
      const response = await triggerRestaurantDetails(restaurantId);
      if (response.data?.restaurant) {
        dispatch(setSelectedRestaurantDetails(response.data.restaurant));
      }
    } catch (error) {
      console.error("Error fetching restaurant details:", error);
      toast.error("Failed to load restaurant details");
    }
  };


  const handleEditAction = (restaurant: Restaurant) => {
    localStorage.setItem("editableRestaurantId", restaurant.id || "");
    navigate("/profile/edit-restaurant", { state: { restaurant } });
  };

  const handleSelectClick = (restaurant: Restaurant) => {
    const selectedRestaurantId = localStorage.getItem("selectedRestaurantId");
    if (!restaurant.id) {
      return;
    }
    if (selectedRestaurantId === restaurant.id) {
      toast.warning("You are already logged in with this restaurant.");
    } else {
      localStorage.setItem("selectedRestaurantId", restaurant.id || "");
      dispatch(openInitialSlectReastaurantModla(true));
      // Get complete restaurant details instead of using the basic restaurant object
      handleSelectRestaurant(restaurant.id || "");
      toast.success("You have successfully moved the login restaurant");
    }
  };

  useEffect(() => {
    if (ownerId) {
      trigger(ownerId);
    }
  }, [ownerId, trigger]);

  const getStatusStyle = (status: any) => {
    switch (status.toLowerCase()) {
      case "approved":
        return { color: "green" };
      case "rejected":
        return { color: "red" };
      default:
        return { color: "#e9b608" };
    }
  };

  // Define columns for the DataTable
  const columns: TableColumn<Restaurant>[] = [
    {
      name: <h6 className="fw-bold">#</h6>,
      cell: (row, index) => index + 1,
      width: "50px",
    },
    {
      name: <h6 className="fw-bold">Restaurant Name</h6>,
      cell: (row) => (
        <div className="restaurant-details-table-restaurant-name">
          <img
            src={row.imageUrl}
            alt="pro_pic"
            className="reastaurant-logo-styling"
          />
          {row.displayName}
        </div>
      ),
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Address</h6>,
      selector: (row) => row.address,
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Authorization</h6>,
      cell: (row) => (
        <span style={getStatusStyle(row.status)}>{row.status}</span>
      ),
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Status</h6>,
      cell: (row) => {
        const openStatus =
          row.openingTime && row.closingTime
            ? isRestaurantOpen(row.openingTime, row.closingTime)
              ? "Open"
              : "Closed"
            : "N/A";
        const openStatusStyle = {
          color:
            openStatus === "Open"
              ? "green"
              : openStatus === "Closed"
                ? "red"
                : "gray",
        };
        return <span style={openStatusStyle}>{openStatus}</span>;
      },
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Action</h6>,
      cell: (row) => {
        const isRejected = row.status?.toLowerCase() === "rejected";
        const isPending = row.status?.toLowerCase() === "pending";
        return (
          <div className="restaurant-details-table-action-icons">
            <div className="button-group">
              <ViewButtonComponent onClick={() => handleEditAction(row)} />
              <Button
                variant="light"
                onClick={() => handleSelectClick(row)}
                title="Select Restaurant"
                className="action-button"
                disabled={isRejected || isPending}
              >
                <FontAwesomeIcon
                  icon={faShuffle}
                  className="restaurant-details-table-action-icon"
                  color="#F24E1E"
                />
              </Button>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="restaurant-details-table-whole-component">
      {isLoading ? (
        <div className="bg-white">
          <TableLoadingComponent numColumns={5} />
        </div>
      ) : (
        data &&
        data.restaurantList.restaurants && (
          <DataTable
            columns={columns}
            data={data.restaurantList.restaurants}
            responsive
            pagination
            highlightOnHover
            pointerOnHover
            noDataComponent={<div className="p-5">No restaurants found</div>}
          />
        )
      )}
    </div>
  );
};

export default RestaurantDetailsTable;
